/**
 * 生成一个 UUID v4 字符串
 * @returns {string} UUID字符串
 */
export function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
};

/**
 * 隐藏手机号中间数字
 * @param {string} phone - 手机号
 * @param {string} maskChar - 隐藏字符，默认 '*'
 * @param {number} start - 开始隐藏位置，默认 3
 * @param {number} end - 结束隐藏位置，默认 7
 * @returns {string} 隐藏后的手机号
 */
export function maskPhone(phone: string, maskChar = '*', start = 3, end = 7) {
  if (!phone) return '';
  
  const cleaned = phone.replace(/\D/g, '');
  
  if (cleaned.length === 11) {
    const prefix = cleaned.substring(0, start);
    const suffix = cleaned.substring(end);
    const mask = maskChar.repeat(end - start);
    return `${prefix}${mask}${suffix}`;
  }
  
  return phone;
}

/**
 * 动态加载JavaScript文件
 * @param {string} src - 脚本文件URL
 * @param {string} id - 脚本标签ID
 * @returns {Promise} 返回Promise对象
 */
export function loadScript (src: string, id: string): Promise<void> {
  return new Promise((resolve, reject) => {
    // 检查是否已经加载过
    if (document.getElementById(id)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
    console.log(`${id}登录插件加载成功`);
  });
};